<template>
  <div class="el-col-24">
    <!-- 已废弃 -->
    <h5 class="warp-title">留言详情</h5>
    <el-descriptions :column="1" border labelClassName="label-box">
      <el-descriptions-item label="平台类型">{{ $getPlatformName(detail.platformType) }}</el-descriptions-item>
      <el-descriptions-item label="平台账号">{{detail.platformAccount}}</el-descriptions-item>
      <el-descriptions-item label="手机号">
        <div class="flex-common-style">
          {{ detail.encryptionPhone }}
          <p class="cursor blue ml10" @click="seePhone(detail.phone)" v-if="phoneViewStatus === 0">查看</p>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="留言时间">{{detail.createTime}}</el-descriptions-item>
      <el-descriptions-item label="处理状态">
        <el-tag v-if="getHandleStatus(detail.handerStatus)" size="medium" :type="getHandleStatus(detail.handerStatus).color">{{getHandleStatus(detail.handerStatus).name}}</el-tag>
      </el-descriptions-item>
      <el-descriptions-item label="留言信息">{{detail.noteInfo}}</el-descriptions-item>
      <el-descriptions-item label="跟进人">{{detail.handerPeopleName}}</el-descriptions-item>
      <el-descriptions-item label="跟进记录">
        <div class="handle-record-list" v-if="detail.followUpRecords && detail.followUpRecords.length > 0">
          <div class="handle-record-item" v-for="(item, index) in detail.followUpRecords || []" :key="index">
            <div class="handle-time">{{ item.createTime }}</div>
            <div class="handle-detail">{{ item.resultRemark }}</div>
          </div>
        </div>
        <div class="no-record-tips">暂无跟进记录</div>
      </el-descriptions-item>
    </el-descriptions>
    <div class="btns-area">
      <el-button type="primary" @click="finish" :loading="isFinishLoading">新增跟进记录</el-button>
      <!-- <el-button type="primary" v-if="detail.handerStatus === 3" @click="finish" :loading="isFinishLoading">处理完成</el-button> -->
      <el-button type="success" @click="finish" :loading="isFinishLoading">处理完成</el-button>
    </div>
  </div>
</template>

<script>
import {queryIMNoteRecordById, imNoteRecordSetHanderStatus} from '../../api/message/index'
export default {
  name: 'MessageDetail',
  created () {
    this.queryIMNoteRecordById()
  },
  data () {
    return {
      handleStatusConfig: [
        {
          name: '待分配',
          value: 1,
          color: 'danger'
        },
        {
          name: '待处理',
          value: 2,
          color: 'warning'
        },
        {
          name: '处理中',
          value: 3,
          color: 'warning'
        },
        {
          name: '已完成',
          value: 4,
          color: 'success'
        }
      ],
      phoneViewStatus: global.$siderItem.phoneViewStatus,
      isFinishLoading: false,
      id: this.$route.params.id,
      detail: {}
    }
  },
  methods: {
    getHandleStatus (value) {
      let item = this.handleStatusConfig.find(item => item.value === value)
      return item || null
    },
    // 查看手机号
    seePhone (phone) {
      this.$alert(phone, '提示', {showConfirmButton: false, closeOnClickModal: true})
    },
    finish () {
      this.$confirm('确定将该留言状态改为 已完成 吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.imNoteRecordSetHanderStatus()
      }).catch(() => {
      })
    },
    imNoteRecordSetHanderStatus () {
      let data = {
        handerStatus: 4,
        id: this.id
      }
      this.isFinishLoading = true
      imNoteRecordSetHanderStatus(data).then(res => {
        this.isFinishLoading = false
        if (res.data.resultCode === 0) {
          this.$message.success('操作成功')
          this.queryIMNoteRecordById()
        } else {
          this.$message.error(res.data.resultMessage)
        }
      }).catch(() => {
        this.isFinishLoading = false
      })
    },
    queryIMNoteRecordById () {
      let data = {
        id: this.id,
        phoneViewStatus: this.phoneViewStatus
      }
      queryIMNoteRecordById(data).then(res => {
        if (res.data.resultCode === 0) {
          this.detail = res.data.resultData
        } else {
          this.$message.error(res.data.resultMessage)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.label-box{
  width: 150px;
}
.handle-record-list{
  .handle-record-item{
    margin-bottom: 10px;
    .handle-time{
      color: #909399;
      margin-bottom: 2px;
    }
  }
}
.no-record-tips{
  color: #999;
}
.btns-area{
  margin-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Message/Detail.vue